import { Checkbox } from "@progress/kendo-react-inputs";
import { cloneElement } from "react";

function MultiSelectItemWithCheckbox(li, itemProps) {
    const itemChildren = (
        <>
            <Checkbox checked={itemProps.selected} />
            {itemProps.dataItem.text}
        </>
    )
    return cloneElement(li, li.props, itemChildren)
}

export default MultiSelectItemWithCheckbox;